/**
 * Vendor
 */
import React from 'react';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Success Alert Service
 *
 * @class      WarningAlertService (name)
 */
function WarningAlertService(component) {
  this.component   = component;
}

WarningAlertService.prototype = Object.assign(WarningAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
WarningAlertService.prototype.registerWarningAlertEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.WARNING_DISPLAY] = 'onWarningDisplay';
  event_callback_map[this.event_group.WARNING_SUCCESS] = 'onWarningSuccess';
  event_callback_map[this.event_group.WARNING_FAIL]    = 'onWarningFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
WarningAlertService.prototype.removeWarningAlertEvents = function() {
  this.removeEvents([
    this.event_group.WARNING_DISPLAY,
    this.event_group.WARNING_SUCCESS,
    this.event_group.WARNING_FAIL
  ]);
  return this;
}


/**
 * Called when success alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
WarningAlertService.prototype.onWarningDisplay = function({
  title='Warning',
  message='',
  confirmText="Save",
  denyText="Don't save",
  showDenyButton=true,
  options={},
  onConfirm,
  onDenied,
  onResolve,
  onError
}) {
  this.createSwal({
    props: {
      title:             <span>{title}</span>,
      html:              message,
      icon:              'warning',
      showCancelButton:  false,
      showDenyButton:    showDenyButton,
      confirmButtonText: confirmText,
      denyButtonText:    denyText,
    },
    options: options,
    onConfirm: onConfirm,
    onDenied:  onDenied,
    onResolve: onResolve,
    onError:   onError,
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
WarningAlertService.prototype.onWarningSuccess = function(response) {
  console.log("WarningAlertService::onWarningSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
WarningAlertService.prototype.onWarningFail = function(error) {
  console.log("WarningAlertService::onWarningFail", error);
}

export default WarningAlertService;